import { gql } from '@apollo/client';

export const GET_COMPANY_CAMPAIGNS = gql`
  query GetCompanyCampaigns($companyId: Int, $pagination: Pagination, $isActive: StringFilter) {
    getCampaigns(filter: { companyId: $companyId, isActive: $isActive }, pagination: $pagination) {
      pageInfo {
        hasNext
        hasPrev
        nextNum
        page
        pages
        perPage
        prevNum
        total
      }
      items {
        shortId
        name
        createdAt
        updatedAt
        status
      }
    }
  }
`;
